import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Stack } from '@optimus-web/core';
import { FullWidthFieldsContainer } from '@mews-commander/ui';
import { CheckboxField, InputField } from '@mews-commander/legacy-form';

interface Props {
    showReason: boolean;
}

const reasonProps = {
    label: <LocalizedText textKey={TextKey.ReservationDetailReasonInputLabel} />,
    name: 'reason',
    required: true,
};

const closeBalancedBillsProps = {
    label: <LocalizedText textKey={TextKey.CloseBalancedBills} />,
    name: 'closeBalancedBills',
};

const checkOutWithUnbalancedBillProps = {
    label: <LocalizedText textKey={TextKey.CheckOutWithUnbalancedBill} />,
    name: 'checkOutWithUnbalancedBill',
};

const CheckOutForm = ({ showReason }: Props) => (
    <FullWidthFieldsContainer>
        <Stack distribution="stretch">
            <CheckboxField {...closeBalancedBillsProps} />
            <CheckboxField {...checkOutWithUnbalancedBillProps} />
        </Stack>
        {showReason ? <InputField {...reasonProps} /> : null}
    </FullWidthFieldsContainer>
);

export default CheckOutForm;
